<template>
    <v-row justify="center">
        <v-dialog
                v-model="dialog"
                max-width="1000px"
                min-width="300px"
        >
            <v-card>

                <v-card-text>
                    <img v-bind:src="painting.url" alt="Painting by Dan Schmidt" class="box" />
                    <v-card>
                        <v-card-text>
                            <div style="text-align: left" v-if="painting.title"><b>{{painting.title }}</b> <span v-if="painting.year"> - <b>{{painting.year}}</b></span></div>

                            <div style="text-align: left"><span v-if="painting.art_width">
                                {{painting.art_width}} x {{painting.art_height}} inches </span></div>
                            <div style="text-align: left"><span v-if="painting.media"> {{painting.media}} </span>
                                <span v-if="painting.material"> on {{painting.material}} </span></div>
                            <div style="text-align: left" v-if="painting.description">{{painting.description}}</div>
                            <div style="text-align: left" v-if="painting.submitted_by">Submitted by: {{painting.submitted_by}}</div>
                        </v-card-text>
                    </v-card>

                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="dialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>

    export default {
        props: {
          painting: {type: Object, required: true}
        },
        data () {
            return {
                dialog: false,
            }
        },
        created() {
        },
        methods: {
            showModal() {
                this.dialog = !this.dialog;
            }
        }
    }
</script>

<style>
    .box {
        /*max-height: 100%;*/
        /*max-width: 100vw;*/
        /*padding-top: 1px;*/
        max-width: 100%;
        padding-top: 10px;
        max-height: 100vh;
    }
</style>
